import SpriteComponent from '../Component/Render/Sprite';
import * as PIXI from 'pixi.js';
import TransformComponent from '../Component/Transform';
import GameObject from '../GameObject/GameObject';
import RelativePositionComponent from '../Component/Render/RelativePosition';
import PIXIRenderer from 'System/Render/PIXIRenderer';

export default class Sprite extends GameObject<PIXI.Sprite> {
    protected instantiateContainer(params: any): void {
        this.container = new PIXI.Sprite(PIXIRenderer.getTexture(params.texture || 'blank'));
    }

    protected onCreate(params: any): void {
        this.addComponent(TransformComponent, params);
        this.addComponent(SpriteComponent, params);

        if (params.relativePosition) {
            this.addComponent<RelativePositionComponent>(RelativePositionComponent, params);
        }
    }
}
